import React from 'react';

const NoProfessionals = props => (
  <svg
    width={50}
    height={50}
    viewBox="0 0 50 50"
    preserveAspectRatio="xMidYMid"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M25.5 31.063c2.188 0 7.292-2.917 7.292-7.292 2.188 0 2.188-4.375 0-4.375l-.729-3.646c-5.833 0-5.833-2.188-6.562-2.917-.73.73-.73 2.917-6.563 2.917l-.729 3.646c-2.187 0-2.187 4.375 0 4.375 0 4.375 5.104 7.29 7.292 7.29v.002Z"
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m21.79 29.624-9.274 2.54a5.83 5.83 0 0 0-3.786 5.46v3.646h33.542v-3.645a5.83 5.83 0 0 0-3.786-5.462l-9.248-2.56m4.996-9.112.746-5.47s.73-7.292-9.479-7.292c-10.208 0-9.479 7.292-9.479 7.292l.745 5.47h17.467Z"
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.96 20.857c0-.806.65-.73 1.457-.73s1.459-.076 1.459.73m-8.75 0c0-.806.652-.73 1.458-.73.807 0 1.458-.076 1.458.73h-2.916Z"
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path clipRule="evenodd" d="m25.5 34.708-4.374 6.563h8.75L25.5 34.708Z" stroke="#224251" strokeLinejoin="round" />
    <path
      d="M33.522 36.896h5.104m-15.313-6.563v2.188a2.188 2.188 0 0 0 4.375 0v-2.188h-4.375Z"
      stroke="#224251"
      strokeLinejoin="round"
    />
    <path d="M5.455 44.545 44.556 5.444" stroke="#fff" strokeWidth={7} strokeLinecap="square" />
    <path d="M5.455 44.545 44.556 5.444" stroke="#224251" strokeLinecap="square" />
  </svg>
);

export default NoProfessionals;
